// extracted by mini-css-extract-plugin
export default {"form":"sorting-page_form__hw9hu","result":"sorting-page_result__QxlxN"};